/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Contact_NameInputs */

const cs_public_site_contact_name = /** @type {(inputs: Public_Site_Contact_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno`)
};

const en_public_site_contact_name = /** @type {(inputs: Public_Site_Contact_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Public_Site_Contact_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_contact_name = /** @type {((inputs?: Public_Site_Contact_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Contact_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_contact_name(inputs)
	return cs_public_site_contact_name(inputs)
});